// extracted by mini-css-extract-plugin
export default {"dropdownToggleClassName":"MmGCg","changeLang":"tHvgr"};